var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { times } from 'lodash';
import { FormField, NumberInput, TableCell } from '../../common';
import { CENTERED_INPUT_PROPS } from './constants';
export var ExtraColumnCells = function (_a) {
    var extraColumns = _a.extraColumns, fieldPrefix = _a.fieldPrefix;
    return (_jsx(_Fragment, { children: extraColumns.map(function (col) { return (_jsx(TableCell, __assign({ align: "center", padding: "none", sx: { minWidth: '6.4rem' } }, { children: _jsx(FormField, __assign({ name: "".concat(fieldPrefix).concat(col.name), disableHelperText: true }, { children: _jsx(NumberInput, { disabled: col.disabled, decimal: col.decimal, min: col.min, max: col.max, placeholder: col.placeholder, suffix: col.suffix, fullWidth: true, inputProps: CENTERED_INPUT_PROPS }) })) }), col.name)); }) }));
};
export var ExtraColumnEmptyCells = function (_a) {
    var count = _a.count;
    return (_jsx(_Fragment, { children: times(count, function (i) { return (_jsx(TableCell, {}, "extra-empty-".concat(i))); }) }));
};
export var ExtraColumnHeaderCells = function (_a) {
    var extraColumns = _a.extraColumns, isSubRow = _a.isSubRow;
    return (_jsx(_Fragment, { children: extraColumns.map(function (col) { return (_jsx(TableCell, __assign({ greyColor: isSubRow, align: "center", sx: { minWidth: '8rem' } }, { children: isSubRow ? '' : col.label }), col.name)); }) }));
};
